import { createSlice } from "@reduxjs/toolkit";

// createing reducer with intial value
export const itemsReducer = createSlice({
  name: "items_store",
  initialState: {
    isAuthenticated: null,
    switchViewIndex: 0,
    addNewItem: {
      itemType: "",
      createVariantsPayloads: {
        option: "",
        values: [],
        imageUrl: "",
        available: "",
        price: "",
      },
      ItemVariants: [],
      createCategoriesPayloads: [],
    },
  },
  reducers: {
    switchView: (state, action) => {
      state.switchViewIndex = action.payload;
    },
    setCreateVariantsPayloads: (state, action) => {
      const { name, value } = action.payload;

      state.addNewItem ??= {};
      state.addNewItem.createVariantsPayloads ??= {
        option: "",
        values: [],
        imageUrl: "",
        available: "",
        price: "",
      };

      state.addNewItem.createVariantsPayloads[name] = value;
    },

    setCreateCategoriesPayloads: (state, action) => {
      const { category } = action.payload;
      state.addNewItem.createCategoriesPayloads = category;
    },

    addVariants: (state, action) => {
      if (!state.addNewItem) state.addNewItem = { ItemVariants: [] };
      if (!state.addNewItem.ItemVariants) state.addNewItem.ItemVariants = [];
      state.addNewItem.ItemVariants.unshift(action.payload);
      state.addNewItem.createVariantsPayloads = {
        option: "",
        values: [],
        imageUrl: "",
        available: "",
        price: "",
      };
    },

    removeFromVariants: (state, action) => {
      const index = action.payload;

      if (
        Array.isArray(state.addNewItem.ItemVariants) &&
        index >= 0 &&
        index < state.addNewItem.ItemVariants.length
      ) {
        state.addNewItem.ItemVariants.splice(index, 1);
      }
    },
    removeFromCategory: (state, action) => {
      const index = action.payload;

      if (
        Array.isArray(state.addNewItem.createCategoriesPayloads) &&
        index >= 0 &&
        index < state.addNewItem.createCategoriesPayloads.length
      ) {
        state.addNewItem.createCategoriesPayloads.splice(index, 1);
      }
    },

    deleteOnholdDispatch: (state, action) => {
      const index = action.payload;

      if (
        state.on_holded_sales &&
        Array.isArray(state.on_holded_sales) &&
        index >= 0
      ) {
        state.on_holded_sales.splice(index, 1);
      }
    },

    clearVariantsAction: (state) => {
      state.addNewItem.ItemVariants = [];
    },

    dispatchCloseRedux: (state) => {
      state.switchViewIndex = 0;
      state.addNewItem.itemType = "";
      state.addNewItem.ItemVariants = [];
    },
    clearAllData: () => {
      return {
        isAuthenticated: null,
        switchViewIndex: 0,
        addNewItem: {
          itemType: "",
          createVariantsPayloads: {
            option: "",
            values: [],
            imageUrl: "",
            available: "",
            price: "",
          },
          ItemVariants: [],
        },
      };
    },
  },
});

export const {
  switchView,
  addVariants,
  removeFromVariants,
  deleteOnholdDispatch,
  clearVariantsAction,
  dispatchCloseRedux,
  setCreateVariantsPayloads,
  setCreateCategoriesPayloads, // 👈 add this
  clearAllData,
  removeFromCategory,
} = itemsReducer.actions;

export default itemsReducer.reducer;
